import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/cloud.png'


const _withScopeId = n => (_pushScopeId("data-v-1f540724"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onDragover", "onDrop"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "wrapper" }

import {inject, ref} from "vue";
import {key} from "@/components/FileManager";
import { toastInjectionKey } from "./Toaster/ToastManager";
import { configInjectionKey, defaultConfig } from "./ConfigManager";
import {i18n} from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploader',
  setup(__props) {

const SUPPORTED_TYPES = ["csv", "txt", "tsv"];

let hovering = ref(false);

const dragEnter = ()=>{hovering.value = true}
const dragLeave = ()=>{hovering.value = false};
const fs = ref(inject(key));
const toaster = inject(toastInjectionKey);
const csvConfig = inject(configInjectionKey, defaultConfig).csvConfig;

const dropFiles = (e:DragEvent)=>{
    hovering.value = false;
    if(!e.dataTransfer){
        return;
    }
    const files = [...e.dataTransfer.files];
    if(files.length === 0){
        toaster?.warning("",i18n.global.tc("error_message.file_anomaly_included"), 2000);
        return;
    }
    console.log(files);
    files.forEach(file=>{
        if(checkFile(file)){
            fs?.value?.register(file, csvConfig);
        }
    });
    
}

const onUpload = (e:Event)=>{
    const files = (e.currentTarget as HTMLInputElement).files;
    if(!files){
        return;
    }
    
    [...files].forEach(file=>{
        if(checkFile(file)){
            fs?.value?.register(file, csvConfig);
        }
    });
}

const checkFile = (file:File)=>{
    if(file.size === 0){
        toaster?.warning(file.name, i18n.global.tc("error_message.file_invalid"), 2000);
        return false;
    }
    if(file.size > 1e7){
        toaster?.warning(file.name, i18n.global.tc("error_message.file_too_large"), 2000);
        return false;
    }
    const ext = file.name.split(".").pop()?.toLowerCase();
    if(!ext){
        toaster?.warning(file.name, i18n.global.tc("error_message.file_ext_not_found"), 2000);
        return false;
    }
    if(!SUPPORTED_TYPES.includes(ext) || !/(application\/octet-stream|application\/vnd.ms-excel|text\/csv|text\/plain)$/.test(file.type)){
        toaster?.warning(file.name, i18n.global.tc("error_message.file_not_supported"), 2000);
        return false;
    }
    return true;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["droparea", {'hovering': _unref(hovering)}]),
    draggable: "true",
    onDragenter: dragEnter,
    onDragleave: dragLeave,
    onDragover: _withModifiers(dragEnter, ["prevent"]),
    onDrop: _withModifiers(dropFiles, ["prevent"])
  }, [
    _hoisted_2,
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t("file_uploader.Choose_files")) + " ", 1),
        _createElementVNode("input", {
          type: "file",
          multiple: "true",
          accept: ".csv",
          onChange: onUpload
        }, null, 32)
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("file_uploader.or_drop_them_here")), 1)
    ])
  ], 42, _hoisted_1))
}
}

})